import _styled from "@emotion/styled/base";

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import * as DesktopNav from '@segment/matcha/recipes/Navigation/DesktopNavigation';
import NavDropdownBase, * as NavDropdown from '@segment/matcha/recipes/Navigation/DesktopNavigation/Dropdown';
import { trackButtonClick } from '@segment/tracking/scripts';
import { usePageConfig } from '@segment/contexts/page';
import docsData from '../../data/docs';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";

var Docs = function Docs() {
  var pageConfig = usePageConfig();

  var _docsData = docsData(pageConfig),
      content = _docsData.content,
      aside = _docsData.aside;

  return _jsxs(NavDropdownBase, {
    children: [_jsxs(NavDropdown.Content, {
      children: [_jsx(DesktopNav.Subheading, {
        children: content.title
      }), _jsxs(DesktopNav.List, {
        children: [content.links.map(function (item) {
          return _jsx("li", {
            role: "none",
            children: _jsx(DesktopNav.Link, {
              title: item.title,
              href: item.url,
              onClick: function onClick() {
                return trackButtonClick({
                  buttonText: item.title,
                  targetUrl: item.url,
                  buttonCampaign: "nav"
                });
              }
            })
          }, item.title);
        }), _jsx("li", {
          role: "none",
          children: _jsx(HighlightedLink, {
            title: content.highlightedLink.title,
            href: content.highlightedLink.url,
            onClick: function onClick() {
              return trackButtonClick({
                buttonText: content.highlightedLink.title,
                targetUrl: content.highlightedLink.url,
                buttonCampaign: "nav"
              });
            }
          })
        })]
      })]
    }), _jsxs(NavDropdown.Tray, {
      children: [_jsx(DesktopNav.Subheading, {
        children: aside.title
      }), _jsx(DesktopNav.List, {
        children: aside.links.map(function (item) {
          return _jsx("li", {
            role: "none",
            children: _jsx(DesktopNav.Link, {
              title: item.title,
              description: item.description,
              href: item.url,
              onClick: function onClick() {
                return trackButtonClick({
                  buttonText: item.title,
                  targetUrl: item.url,
                  buttonCampaign: "nav"
                });
              }
            })
          }, item.title);
        })
      })]
    })]
  });
};

var HighlightedLink = /*#__PURE__*/_styled(DesktopNav.LinkHighlighted, true ? {
  target: "e10vqfck0"
} : {
  target: "e10vqfck0",
  label: "HighlightedLink"
})(true ? {
  name: "hkh81z",
  styles: "margin-top:8px"
} : {
  name: "hkh81z",
  styles: "margin-top:8px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export default Docs;